import { Mail } from 'iconoir-react';
import React from 'react'
import Swal from 'sweetalert2';
import { domain } from '../../../../Urls/Services/Api_urls';

const EmailChange = (props) => {
  const tableMeta = props.tableMeta;
  const idp = tableMeta.id;


  const token = window.sessionStorage.getItem("token");
  const groups = window.sessionStorage.getItem("groups");

  const handleSubmit = async (e) => {
    e.preventDefault();
    Swal.fire({

      title: "Cambio de correo del usuario",
      html: `
                            <form>
                              <div class="m-3">
                                  <div class="row mb-4">
                                      <label for="NameLabelUpdate" class="labelFount" >Correo nuevo</label>
                                      <input id="swal-email" class="form-control" rows="5" placeholder="Escribe el nuevo correo"></input>
                                  </div>
                              </div>
                            </form>
                            `,
      focusConfirm: false,
      confirmButtonText: "Cambiar",
      preConfirm: () => {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token} `);
        myHeaders.append("Content-Type", "application/json");
        var raw = JSON.stringify({
          mail:
            document.getElementById("swal-email").value,
          id: idp,
        });
        var requestOptions = {
          method: "PUT",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };
        fetch(
          domain +
          "/portal/" +
          idp +
          "/update_mail_pap/",
          requestOptions
        )
          .then((response) => response.json())
          .then((result) =>
            Swal.fire({
              icon: "success",
              titleText: result.msg,
              allowOutsideClick: false,
              timer: 2000,
              timerProgressBar: true,
            }).then(() => {
              window.location.reload();
            })
          )
          .catch((error) => Swal.fire({
            icon: "error",
            titleText: error,
            allowOutsideClick: false,
            timer: 2000,
            timerProgressBar: true,
          }));
      },
    });
  };

  if (
    tableMeta.is_actived !== "Orden creada" &&
    tableMeta.is_actived !== "Rechazado"
  ) {
    // setstep("none");
    return (
      <>
        <button
         className='p-1 cursor-pointer bg-[#5C19A0] hover:bg-colorprimary text-white rounded-md transition-colors'
         onClick={handleSubmit}
         title="Cambiar correo">
          <Mail  />
        </button>
      </>
    );
  } else {
    return null;
  }
};

export default EmailChange;